<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div id="inreadyContent" class="inready-content">
    <lms-terminal-bound-status [allData]="allData" [onTermEachSlideHeight]='getHeight(status.key)' [isDroppable]="droppable[status.key]" *ngFor="let status of allData.terminalStatusLocos | keys" [tab]="tab" [status]="status.value" [statusHeader]="status.key"
        [actualNoOfVisible]="actualNoOfVisible" [numOfVisible]="numOfVisible" [firstVisible]="firstVisibleData[status.key]?.firstVisible" (onLocoSelect)='showLocoContextMenu($event);' (hideContextMenu)='hideContextMenuPanel($event);' (updateLocos)="updateLocosCarousel($event)"
        (heightCalculate)='heightCalculateEmit($event);'></lms-terminal-bound-status>
</div>